module.exports = __webpack_public_path__ + "img/task-empty-bg.4747590f.png";